import { MeterStatusThresholdDraft } from "../models/MeterStatusThreshold";

export type MeterStatusMetric = "Lag" | "Coverage";

export type MeterStatusLevel =
	| "Reporting"
	| "Late"
	| "NoData"
	| "Low"
	| "Partial"
	| "Full";

export const METER_STATUS_LABELS: Record<MeterStatusLevel, string> = {
	Reporting: "Reporting",
	Late: "Late",
	NoData: "Stale",
	Low: "Low",
	Partial: "Partial",
	Full: "Complete",
};

export const DEFAULT_METER_STATUS_THRESHOLDS: MeterStatusThresholdDraft[] = [
	{
		Metric: "Lag",
		Level: "Reporting",
		Threshold: 0,
		Color: "#2E7D32",
		BackgroundColor: "#E8F5E9",
	},
	{
		Metric: "Lag",
		Level: "Late",
		Threshold: 12,
		Color: "#B26A00",
		BackgroundColor: "#FFF4E0",
	},
	{
		Metric: "Lag",
		Level: "NoData",
		Threshold: 48,
		Color: "#C62828",
		BackgroundColor: "#FDECEA",
	},
	{
		Metric: "Coverage",
		Level: "Low",
		Threshold: 0,
		Color: "#C62828",
		BackgroundColor: "#FDECEA",
	},
	{
		Metric: "Coverage",
		Level: "Partial",
		Threshold: 60,
		Color: "#B26A00",
		BackgroundColor: "#FFF4E0",
	},
	{
		Metric: "Coverage",
		Level: "Full",
		Threshold: 99,
		Color: "#1565C0",
		BackgroundColor: "#E8F1FB",
	},
];

export const getMeterStatusBands = (
	drafts: MeterStatusThresholdDraft[],
	metric: MeterStatusMetric,
): MeterStatusThresholdDraft[] =>
	drafts.filter((draft) => draft.Metric === metric && draft.Threshold !== null);

export const resolveMeterStatusBand = (
	drafts: MeterStatusThresholdDraft[],
	metric: MeterStatusMetric,
	value: number,
): MeterStatusThresholdDraft => {
	const bands = getMeterStatusBands(drafts, metric);
	return (
		[...bands].reverse().find((band) => value >= band.Threshold) ?? bands[0]
	);
};
